const upsellInputPrefix = 'upsell-addon-input-popup-custom-';
const popUpId = 'pop-up-window';
const modalId = 'un-modal-content';

export { popUpId, modalId, upsellInputPrefix };
